import React from 'react';
import { SUBHOME_LAYOUT } from 'volto-ministerio-publico-federal/constants';

interface BlockComponentProps {
  /** Conteúdo em volta do bloco. Na leitura é o objeto; na edição, o form. */
  properties?: { layout?: string; [key: string]: unknown };
  [key: string]: unknown;
}

/**
 * Envolve o bloco de texto num cartão quando a página está na Sub-home.
 *
 * A anotação do Figma: "Para diferenciar de um texto em uma página 'normal',
 * o texto na sub-home deve estar em um container com fundo aplicado, para dar
 * destaque."
 *
 * Por que um HOC sobre o bloco do core, e não CSS descendente de
 * `.mpf-subhome`: em modo de leitura o `RenderBlocks` do Volto não põe
 * wrapper nenhum em volta de cada bloco (o `StyleWrapper` só emite um `<div>`
 * quando há estilos gravados), então não há nó estável para o seletor pegar.
 * Por que não uma cópia do bloco `slate`: seria congelar o editor de texto
 * inteiro do volto-slate só para trocar uma moldura.
 *
 * A decisão sai de `properties.layout`, que é o campo do próprio conteúdo.
 *
 * Aplicado só à `view` do bloco (ver `config/blocks/enhancers/slate.ts`): a `edit` do
 * volto-slate é um componente conectado com gestão própria de foco e seleção,
 * e envolvê-la seria risco desnecessário por um ganho só cosmético na canvas
 * do editor.
 */
export const withSubHomeCard = <P extends BlockComponentProps>(
  Component: React.ComponentType<P>,
): React.FC<P> => {
  const SubHomeAware: React.FC<P> = (props) =>
    props?.properties?.layout === SUBHOME_LAYOUT ? (
      <div className="mpf-subhome__texto">
        <Component {...props} />
      </div>
    ) : (
      <Component {...props} />
    );

  SubHomeAware.displayName = `withSubHomeCard(${
    Component?.displayName || Component?.name || 'Block'
  })`;

  return SubHomeAware;
};

export default withSubHomeCard;
